export default "__VITE_ASSET__D$4zpDi$__"